import { memo } from "react";
import { BsDatabase } from "react-icons/bs";

const LogoIcon = memo(({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) => {
  const dims = { lg: 'w-8 h-8', md: 'w-7 h-7', sm: 'w-6 h-6' }[size];
  const iconSize = { lg: 20, md: 16, sm: 14 }[size];
  return (
    <div className={`${dims} rounded bg-white/15 flex items-center justify-center shrink-0`}>
      <BsDatabase size={iconSize} className="text-white" />
    </div>
  );
});

export default LogoIcon;